<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area esg04">
      <img :src="`${resources}img/img-top-sub-title15.jpg`" alt="" />
      <div class="tit_area">
        <div class="sub_tit">품질경영</div>
        <div class="sub_txt">
          고객중심의 품질경영관리를 통해 최고의 품질로 보답하겠습니다.
        </div>
      </div>
    </div>
    <!--// sub title -->

    <!-- sub contents -->
    <div class="sub_contents">
      <div class="sub_cont_txt">
        한국오션플랫폼은 최고의 품질로 ‘고객 만족’을 실현하기 위해 노력합니다.
        사업 전 영역에서 체계적인 품질 관리 체계를 수립하는 한편, 모든 임직원이
        적극적으로 품질 개선에 참여하며 고객의 가치 창출에 기여하기 위해
        끊임없이 혁신하고 있습니다.
      </div>
      <h3>품질경영전략</h3>
      <div class="mgt20">
        <img
          :src="`${resources}img/img_esg04_01.png`"
          alt="1번째 품질개선을 통한경영이익 극대화, 2번째 미래지향 설비투자로 품질 향상, 3번째 품질관리 전문역량 강화, 4번째 고객 불만 제로 실현"
        />
      </div>
      <h3>품질경영활동</h3>
      <div class="esg_cont04_01">
        <strong>PC건설 선도기업</strong>
        <p>품질 향상 인프라 개선 및 경쟁력 확보로 고객 가치 실현</p>
        <ul class="esg_cont04_cont">
          <li>
            <p>손실 발생 최소화</p>
            <ul>
              <li>원자재 리스크 최소화</li>
              <li>최적 설계로 원/부자재 사용 손실 최소화</li>
            </ul>
          </li>
          <li>
            <p>부적합율 제로화</p>
            <ul>
              <li>품질사고 및 품질 실패 비용 발생 원인 집중 관리</li>
              <li>협력사 검수 R&R 체계 구축</li>
            </ul>
          </li>
          <li>
            <p>지속적 제도 개선</p>
            <ul>
              <li>품질 개발 아이디어 창출</li>
              <li>불량 원인 분석 및 개선</li>
            </ul>
          </li>
        </ul>
      </div>

      <h3>인증서 다운로드</h3>
      <div class="esg_cont_list mgt0">
        <div class="esg_cont_img">
          <img :src="`${resources}img/img_esg04.png`" alt="" />
        </div>
        <div class="esg_cont_txt">
          <p class="esg_tit2">품질경영시스템 인증서</p>
          <div class="esg_txt">
            1) 인 증 기 관 : 에스비씨인증원(SBCR)<br />
            2) 최초 취득일: 2012년 05월 11일<br />
            3) 인증 만료일: 2024년 05월 10일
            <div class="esg_txt2">
              <strong>인증표준: KS Q ISO 9001:2015 / ISO 9001:2015</strong
              ><br />
              인증범위: 철근콘크리트 PC제품의 설계, 개발 및 생산
            </div>
            <div class="down_area">
              <a
                class="btn_down"
                href="/files/pdf/품질경영시스템_ISO9001 한글인증서.pdf"
                target="_blank"
                rel="noreferrer noopener"
                >KOREAN PDF</a
              >
              <a
                class="btn_down"
                href="/files/pdf/품질경영시스템_ISO9001 영문인증서.pdf"
                target="_blank"
                rel="noreferrer noopener"
                >ENGLISH PDF</a
              >
            </div>
          </div>
        </div>
      </div>
      <div class="esg_cont_list">
        <div class="esg_cont_img">
          <img :src="`${resources}img/img_esg05.png`" alt="" />
        </div>
        <div class="esg_cont_txt">
          <p class="esg_tit2">HCS 내화구조인정서</p>
          <div class="esg_txt">
            1) 인 증 기 관 : 한국건설기술연구원(KICT)<br />
            2) 최초 취득일: 2021년 06월 17일<br />
            3) 인증 만료일: 2026년 06월 16일
            <div class="esg_txt2">
              <strong>내화구조인정서 승인 및 발급 공표(2021.06.17)</strong
              ><br />
              <a class="link_blue" href="#none"
                >PC건설업체 중 최초 내화구조인정 취득(한국오션플랫폼)</a
              ><br />
              인정명: 프리스트레스 HCS 200단면, 265단면
            </div>
            <div class="down_area">
              <a
                class="btn_down"
                href="/files/pdf/한국오션플랫폼_HCS200 내화구조인정서.pdf"
                target="_blank"
                rel="noreferrer noopener"
                >HCS 200단면</a
              >
              <a
                class="btn_down"
                href="/files/pdf/한국오션플랫폼_HCS265 내화구조인정서.pdf"
                target="_blank"
                rel="noreferrer noopener"
                >HCS 265단면</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>

<script>
import page from '@/mixins/page';
export default {
  mixins: [page]
};
</script>

<style lang="scss" scoped></style>
